// Scripts for tracking custom events in Fathom Analytics.

window.addEventListener("load", (event) => {
  // Track button clicks
  // ## This script listens for clicks on buttons with the class "btn" and tracks the event in Fathom Analytics.
  // ## If the button has a data-event attribute, it will use that as the event name.
  // ## If it also has a data-event-type attribute, it will append that to the event name.
  // ## If neither attribute is present, it will track the event as a generic "button click".

  document.querySelectorAll(".btn, .card-featured-link").forEach((item) => {
    item.addEventListener("click", (event) => {
      let eventName;
      if (item.hasAttribute("data-event")) {
        eventName = item.getAttribute("data-event");
        if (item.hasAttribute("data-event-type")) {
          eventName = eventName + ": " + item.getAttribute("data-event-type");
        }
        fathom.trackEvent(eventName);
      }
      // if no data-event attribute is set, interaction will not be recorded
    });
  });

  // Track clicks on social media account links
  // ## This script listens for clicks on buttons with the class "btn" and tracks the event in Fathom Analytics.
  // ## If the button has a data-event attribute, it will use that as the event name.
  // ## If it also has a data-event-type attribute, it will append that to the event name.
  // ## If neither attribute is present, it will track the event as a generic "button click".

  document.querySelectorAll(".connect").forEach((item) => {
    item.addEventListener("click", (event) => {
      let url = new URL(item.getAttribute("href"));
      let domainParts = url.hostname.split(".");
      let domainName =
        domainParts.length > 1
          ? domainParts[domainParts.length - 2]
          : domainParts[0];

      fathom.trackEvent(`Connect: ${domainName}`);
    });
  });
});
